module.exports = __webpack_public_path__ + "static/media/logo.4c1deba8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/login/logo.png
// module id = 12
// module chunks = 0